import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
// import "./assets/css/style.css";
import "./assets/css/styleX.less";

import PrivateLayout from "components/Layout/Private";
import PublicLayout from "components/Layout/Public";

import useAuth from "utils/auth/hooks";

function App() {
  const { data, methods } = useAuth();

  useEffect(() => {
    methods.checkVersion();
  }, []);

  return (
    <BrowserRouter>
      {data.isAuthenticated && !data.userData?.userInfo?.requirePasswordChange 
        ? <PrivateLayout /> 
        : <PublicLayout />
      }
    </BrowserRouter>
  );
}

export default App;
